import { render, staticRenderFns } from "./DonutChart73.vue?vue&type=template&id=1332b712&scoped=true"
import script from "./DonutChart73.vue?vue&type=script&lang=js"
export * from "./DonutChart73.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332b712",
  null
  
)

export default component.exports